import { Injectable } from '@angular/core';
import {LicenseType, User} from '@uofu-uss-aux/software-catalog-ng-core';

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {

  constructor() { }


  determineAllowedLicenseTypes(user: User): ReadonlyArray<LicenseType> {
    const licenseTypes = user.employee ? [LicenseType.Employee, LicenseType.University] : [];
    if (user.student) {
      licenseTypes.push(LicenseType.Student);
    }
    return licenseTypes;
  }
}
